import React from 'react';
import { Issuer } from '../../redux/types';

type Props = {
    issuer?: Issuer;
};

const IssuerInfo: React.FC<Props> = ({ issuer }) => {
    return (
        <div className="flex flex-wrap pt-6">
            <div className="w-full sm:w-full md:w-2/3 font-[WorkSans]">
                <div className="flex-col">
                    <p className="text-lg">{issuer?.name}</p>
                    <p className="text-base text-gray-500">{issuer?.country}</p>
                    <p className="text-base pt-3 text-gray-500 text-justify">{issuer?.description}</p>
                </div>
            </div>
            <div className="w-full sm:w-full md:w-1/3 pt-3 md:pt-0 md:pl-3">
                {issuer?.logo && <img src={issuer?.logo} alt="issuerLogo" />}
            </div>
        </div>
    );
};

export default IssuerInfo;
